import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/logout.jpg'
import _imports_1 from '@/assets/images/logos/sidebarlogo.png'


const _hoisted_1 = { class: "bg-white dark:bg-[#0a0e19] py-[60px] md:py-[80px] lg:py-[135px]" }
const _hoisted_2 = { class: "mx-auto px-[12.5px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1255px]" }
const _hoisted_3 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-[25px] items-center" }
const _hoisted_4 = { class: "xl:ltr:pl-[90px] xl:rtl:pr-[90px] 2xl:ltr:pl-[120px] 2xl:rtl:pr-[120px] order-1 lg:order-2" }
const _hoisted_5 = { class: "flex items-center mb-[20px]" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "font-semibold text-black dark:text-white block" }

import { ref, onMounted } from 'vue';
import { supabase } from '@/lib/supabaseClient';
import { defineComponent } from 'vue';
import { authService } from "@/utils/supabase";
import { useRouter } from "vue-router";

// Define a multi-word component name

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

defineComponent({
  name: 'LogoutPage',
});

const router = useRouter();
const userName = ref('User');
const userAvatar = ref('/src/assets/images/admin.png');

// Get user data before logout for display
const getUserDataBeforeLogout = async () => {
  try {
    // Get user session from localStorage if available
    const storedSession = localStorage.getItem('sb-session');
    if (storedSession) {
      const session = JSON.parse(storedSession);
      const { data: profile } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', session.user.id)
        .single();

      if (profile) {
        userName.value = profile.full_name || profile.username || 'User';
        userAvatar.value = profile.avatar_url || '/src/assets/images/admin.png';
      }
    }
  } catch (error) {
    console.error('Error fetching user profile', error);
  }
};

const performLogout = async () => {
  try {
    await getUserDataBeforeLogout(); // Get user data before logout for display purposes
    
    // Perform actual logout
    const { error } = await authService.logout();
    
    if (error) {
      console.error('Logout error:', error);
    }
    
    // Clear any local storage items that might contain user data
    localStorage.removeItem('sb-session');
    localStorage.removeItem('supabase.auth.token');
    
    // Prevent going back to authenticated pages with browser back button
    if (window.history && window.history.pushState) {
      window.history.pushState(null, '', window.location.href);
      window.onpopstate = function() {
        router.push('/authentication/sign-in');
      };
    }
  } catch (error) {
    console.error('Error during logout:', error);
  }
};

onMounted(async () => {
  await performLogout();
});

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "xl:ltr:-mr-[25px] xl:rtl:-ml-[25px] 2xl:ltr:-mr-[45px] 2xl:rtl:-ml-[45px] rounded-[25px] order-2 lg:order-1" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: "logout-image",
            class: "rounded-[25px]"
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createStaticVNode("<img src=\"" + _imports_1 + "\" alt=\"logo\" class=\"inline-block dark:hidden max-w-[200px]\"><img src=\"" + _imports_1 + "\" alt=\"logo\" class=\"hidden dark:inline-block max-w-[200px]\"><div class=\"my-[17px] md:my-[25px]\"><h1 class=\"font-semibold text-[22px] md:text-xl lg:text-2xl mb-[5px] md:mb-[10px]\"> Welcome back to Trezo! </h1><p class=\"font-medium leading-[1.5] lg:text-md text-[#445164] dark:text-gray-400\"> You Are Logged out </p></div>", 3)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: userAvatar.value,
              alt: "admin-image",
              class: "rounded-full w-[50px] border-[2px] ltr:mr-[13px] rtl:ml-[13px] border-primary-200"
            }, null, 8, _hoisted_6),
            _createElementVNode("span", _hoisted_7, _toDisplayString(userName.value), 1)
          ]),
          _createVNode(_component_RouterLink, {
            to: "/authentication/sign-in",
            class: "md:text-md block w-full text-center transition-all rounded-md font-medium py-[12px] px-[25px] text-white bg-primary-500 hover:bg-primary-400"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "flex items-center justify-center gap-[5px]" }, [
                _createElementVNode("i", { class: "material-symbols-outlined" }, " autorenew "),
                _createTextVNode(" Sign In ")
              ], -1)
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})